import { useState } from 'react';
import './Faq.css';

import faqStars from '../../assets/alliatus/faq-stars.png';
import faqChevron from '../../assets/alliatus/faq-chevron.svg';

const FAQS = [
    {
        q: 'How does Numus find roles for me?',
        a: 'Numus combines your profile with AI matching, market data, and network signals to prioritize roles where you have the strongest fit and outreach advantage.',
    },
    {
        q: 'Do I need to connect my professional network?',
        a: 'It’s optional but powerful. Connecting network data helps surface warm intros and mutual connections so your outreach isn’t starting from zero.',
    },
    {
        q: 'Is my data private and secure?',
        a: 'Yes. Your profile and connected data are used to power your search. We don’t sell your information, and you control what you share.',
    },
    {
        q: 'Is there a long-term commitment?',
        a: 'No. Starter is free, and paid plans are billed monthly. Cancel anytime — stay only as long as Numus is helping your search.',
    },
    {
        q: 'Who is Numus built for?',
        a: 'Job seekers and career movers who want a smarter search — professionals who prefer targeted matches and network-backed outreach over mass applications.',
    },
];

function Faq() {
    const [openFaq, setOpenFaq] = useState(0);

    return (
        <section className="al-section" id="faq">
            <div className="al-shell">
                <div className="al-faq-layout">
                    <div className="al-faq-intro">
                        <p className="al-eyebrow">Need More Info?</p>
                        <h2 className="al-display">
                            Frequently Asked <span className="al-em">Questions</span>
                        </h2>
                    </div>
                    <div className="al-faq-art" aria-hidden="true">
                        <img src={faqStars} alt="" />
                    </div>
                    <div className="al-faq-list">
                        {FAQS.map((item, index) => {
                            const isOpen = openFaq === index;
                            return (
                                <div
                                    className={`al-faq-item ${isOpen ? 'is-open' : ''}`}
                                    key={item.q}
                                >
                                    <button
                                        className="al-faq-trigger"
                                        type="button"
                                        aria-expanded={isOpen}
                                        onClick={() => setOpenFaq(isOpen ? -1 : index)}
                                    >
                                        <span>{item.q}</span>
                                        <img
                                            src={faqChevron}
                                            alt=""
                                            className={isOpen ? 'is-flipped' : ''}
                                        />
                                    </button>
                                    {isOpen && <p className="al-body al-faq-answer">{item.a}</p>}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Faq;
